import React, { Dispatch, SetStateAction, useContext, useMemo } from 'react';
import DatePicker from '@components/DatePicker';
import moment, { Moment } from 'moment';
import SessionContext from '@providers/Session/SessionContext';

type useNetworkUnblockType = {
  renderParamTitle: (title: string) => JSX.Element;
  unblockDate: Moment | null;
  setUnblockDate: Dispatch<SetStateAction<Moment | null>>;
};

const useNetworkUnblock = ({
  renderParamTitle,
  unblockDate,
  setUnblockDate,
}: useNetworkUnblockType) => {
  const { theme } = useContext(SessionContext);

  const netWorkUnblockStep = useMemo(() => {
    return (
      <div style={{ padding: '24px 0px', color: theme?.colors?.text1 }}>
        {renderParamTitle('unlock-date')}
        <div className="network-block-datepicker">
          <DatePicker
            value={unblockDate}
            onChange={(date: Moment | null) => {
              setUnblockDate(date);
            }}
            disabledDate={current => {
              return (
                current && current.startOf('day') < moment().startOf('day')
              );
            }}
            hideFooter
          />
        </div>
      </div>
    );
  }, [renderParamTitle, setUnblockDate, theme?.colors?.text1, unblockDate]);

  return {
    netWorkUnblockStep,
  };
};

export default useNetworkUnblock;
